<template>
  <router-link :to="link.url" class="nav-link group" :class="{ 'nav-link--active': isActive }" @click="$emit('click')">
    {{ link.text }}
  </router-link>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ISiteNavLink } from '@/composables/useSiteNavigation';

export default defineComponent({
  name: 'SiteHeaderLink',

  emits: ['click'],

  props: {
    link: {
      type: Object as PropType<ISiteNavLink>,
      required: true,
    },
  },

  computed: {
    isActive(): boolean {
      const url = this.link.url;
      if (url.startsWith('/#')) {
        if (this.$route.path !== '/') {
          return false;
        }
        const sectionId = url.slice(2);
        if (!sectionId) {
          return false;
        }
        const fromHash = this.$route.hash === `#${sectionId}`;
        const fromScroll =
          this.$store.getters['app/getHomeScrollSection'] === sectionId;
        return fromHash || fromScroll;
      }
      return this.$route.fullPath.includes(url);
    },
  },
});
</script>
